import React from 'react';
import { Body, Button, Flex } from '@cognite/cogs.js';
import { DrawerSteps } from 'components/DrawerSteps/DrawerSteps';
import { DrawerWithTitle } from '../components/Schemas/ViewSchemaPage/ProjectRuleset/components/DrawerWithTitle';
import { DigitalTwin } from 'types/graphql-apollo-v2';
import { ConsistencyCollectionView } from './types';
import { useNewConsistencySchemaFilterDrawer } from './useNewConsistencySchemaFilterDrawer';
import { buildSchemaFilterSteps } from './NewConsistencySchemaFilterDrawer.steps';

type NewConsistencySchemaFilterDrawerProps = {
  visible: boolean;
  onClose: VoidFunction;
  collection: ConsistencyCollectionView | null;
  digitalTwin: DigitalTwin;
};

export const NewConsistencySchemaFilterDrawer = (
  props: NewConsistencySchemaFilterDrawerProps
) => {
  const hookResult = useNewConsistencySchemaFilterDrawer(props);
  const {
    currentStep,
    setCurrentStep,
    creating,
    hasInvalidValues,
    onCreateSchemaFilter,
    onCancelHandler,
  } = hookResult;

  const steps = buildSchemaFilterSteps(hookResult);

  return (
    <DrawerWithTitle
      footer={
        <Flex justifyContent="flex-end" alignItems="center" gap={8}>
          <Button onClick={onCancelHandler}>Cancel</Button>
          <Button
            type="primary"
            onClick={onCreateSchemaFilter}
            loading={creating}
            disabled={creating || hasInvalidValues}
          >
            Create schema filter
          </Button>
        </Flex>
      }
      onCancel={onCancelHandler}
      selectedMilestoneName={props.collection?.name}
      subHeader={
        <Body size="medium">
          Define a filtered dataset from a schema. Filters can span multiple
          types and attributes for flexible consistency checking.
        </Body>
      }
      title="Create consistency schema filter"
      visible={props.visible}
    >
      <DrawerSteps
        steps={steps}
        currentStep={currentStep}
        onChangeStep={(step: number) => setCurrentStep(step)}
      />
    </DrawerWithTitle>
  );
};
